export default class PubSub {
    constructor() {
        this.events = {};
    }

    /**
     * Either create a new event instance for passed `event` name.
     * or push a new callback into the existing collection.
     * @param {string} event The event name to subscribe to
     * @param {Function} callback The callback function to subscribe to the event
     * @returns {number} A count of callbacks for this event
     * @memberof PubSub
     */
    subscribe(event, callback) {
        let self = this;
        let index;

        // If there's not already an event with this name set in our collection
        // go ahead and create a new one and set it with an empty array, so we don't
        // have to type check it later down-the-line
        if (!self.events.hasOwnProperty(event)) {
            self.events[event] = [];
        }

        index = self.events[event].push(callback) - 1;

        return {
            unsubscribe() {
                self.events[event].splice(self.events[event].indexOf(callback), 1);
            },
        };
    }

    /**
     * If the passed event has callbacks attached to it, loop through each one and call it.
     * @param {string} event The name of the event to publish
     * @param {any} state The current state to pass to the callbacks
     * @param {object} [newData] The new data to pass to the callbacks
     * @param {object} [oldData] The old data to pass to the callbacks
     * @returns {Array} The results of the callbacks for this event, or an empty array if no event exists
     * @memberof PubSub
     */
    publish(event, state, newData = {}, oldData = {}) {
        let self = this;

        // There's no event to publish to, so bail out
        if (!self.events.hasOwnProperty(event)) {
            return [];
        }

        // Get each subscription and call its callback with the passed data
        return self.events[event].map((callback) => callback(state, oldData, newData));
    }
}
